import React, { useState } from 'react'
import { IconButton } from '@material-ui/core'
import NotificationsNoneIcon from '@material-ui/icons/NotificationsNone'
import { withRouter } from 'react-router-dom'
import AuthService from 'tools/AuthService'
import { useNotifications } from './hooks/useNotifications'
import NotificationDropdown from './NotificationDropdown'
import './NotificationBell.scss'

const NotificationBell = ({ history }) => {
    const { activityDashboardEnabled, monitoringEnabled, monitoringAdvancedEnabled, isReadOnlyUser } = AuthService.getClientFeatures() || {}
    const [anchorEl, setAnchorEl] = useState(null)
    const open = !!anchorEl

    const { items, unreadCount, loading, error, markRead, markAll } = useNotifications({
        enabled: activityDashboardEnabled
    })

    if (!activityDashboardEnabled) return null

    const handleOpen = (e) => setAnchorEl(e.currentTarget)
    const handleClose = () => setAnchorEl(null)

    const handleRowClick = async (notification) => {
        if (!notification.read) markRead(notification.id)
        handleClose()
        // General (non-task) notifications carry their own deep-link (e.g. monitoring → /monitoring).
        if (notification.link) {
            history.push(notification.link)
            return
        }
        const taskUuid = notification.task?.id
        const appUuid = notification.task?.applicationUuid
        if (appUuid) {
            // Deep-link to the application's Tasks tab; TasksTab reads ?task= to open the drawer.
            const url = `/applicant/${appUuid}?tab=tasks${taskUuid ? `&task=${taskUuid}` : ''}`
            history.push(url)
        }
    }

    const handleViewAll = () => {
        // Jump from the most recent unread (or first) notification: its own link, else its task's tab.
        const target = items.find(i => !i.read) || items[0]
        if (!target) return
        handleClose()
        if (target.link) {
            history.push(target.link)
        } else if (target.task?.applicationUuid) {
            history.push(`/applicant/${target.task.applicationUuid}?tab=tasks`)
        }
    }

    return (
        <div className="nbell-top-bar">
            <div className="nbell-anchor">
                <IconButton
                    className="nbell-icon-btn"
                    onClick={handleOpen}
                    aria-label="notifications"
                >
                    <NotificationsNoneIcon style={{ fontSize: 20 }} />
                    {unreadCount > 0 && <span className="nbell-icon-btn__dot">{unreadCount > 9 ? '9+' : unreadCount}</span>}
                </IconButton>

                <NotificationDropdown
                    error={error}
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    items={items}
                    unreadCount={unreadCount}
                    loading={loading}
                    onRowClick={handleRowClick}
                    onMarkAllRead={markAll}
                    onViewAll={handleViewAll}
                    onOpenSettings={monitoringEnabled && monitoringAdvancedEnabled && !isReadOnlyUser
                        ? () => { handleClose(); history.push('/profile?tab=notifications') }
                        : undefined}
                />
            </div>
        </div>
    )
}

export default withRouter(NotificationBell)
